
import RequestAbstract from "../abstract";

export default class Currencies extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/currencies";
    }

}

